import { BindingEngine } from "aurelia-binding";
import { autoinject, transient } from "aurelia-dependency-injection";
import { I18N } from "aurelia-i18n";
import { Router } from "aurelia-router";
import { BaseInspectorTab } from "../base-inspector-tab";
import { useView } from "aurelia-framework";

@autoinject
@transient()
@useView('views/pages/admin/inspectors/tabs/inspector-overview.html')
export class InspectorsOverview extends BaseInspectorTab {

    constructor(i18N: I18N, router: Router, bindingEngine: BindingEngine) {
        super(i18N, router, bindingEngine);
    }

    protected setDefaultFilters(): void {
    }

    protected clearAllFilters(): void {
    }
}